import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const applyCoupon = async (
  coupon: any,
  bookingId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      `/api/bookings/${bookingId}/apply_coupon/`,
      { coupon_name: coupon }
    );

    return response.data;
  } catch (error) {
    // Routed through renterError like every other api/** call site, so a real
    // backend message (e.g. an expired-coupon reason) still reaches the renter
    // instead of a fixed generic string.
    return { error: renterError(error, "coupon") };
  }
};
export const removeCoupon = async (
  coupon: any,
  bookingId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      `/api/bookings/${bookingId}/remove_coupon/`,
      { coupon_name: coupon }
    );

    return response.data;
  } catch (error) {
    return { error: renterError(error, "coupon") };
  }
};
